export const recentBlogs = [
  {
    category: "Glossary",
    title: "What Is Note Making? Advantages, Procedures, and Key Points",
    author: "Savit Ads",
    date: "Jul 02, 2026",
    image: "/images/Education_Funds.png",
    href: "#",
  },
  {
    category: "How to",
    title:
      "How Listening is the Key to Communicating and Building Trust with Teenagers?",
    author: "Savit Ads",
    date: "Jul 02, 2026",
    image: "/images/Education_Funds1.png",
    href: "#",
  },
  {
    category: "Guide",
    title: "The Role of Assessment Beyond Marks and Grades",
    author: "Savit Ads",
    date: "Jul 02, 2026",
    image: "/images/Education_Funds2.png",
    href: "#",
  },
  {
    category: "Blog",
    title: "Importances of Parents and Teachers Meeting at School",
    author: "Savit Ads",
    date: "Jul 02, 2026",
    image: "/images/Education_Funds3.png",
    href: "#",
  },
  {
    category: "Glossary",
    title: "7 Challenges Parents Face When Raising Preschoolers",
    author: "Master Admin",
    date: "May 06, 2026",
    image: "/images/Education_Funds4.png",
    href: "#",
  },
];

export const mostRead = [
  {
    title: "What Is Note Making? Advantages, Procedures, and Key Points",
    href: "#",
  },
  {
    title:
      "How Listening is the Key to Communicating and Building Trust with Teenagers?",
    href: "#",
  },
  {
    title: "The Role of Assessment Beyond Marks and Grades",
    href: "#",
  },
  {
    title: "Importances of Parents and Teachers Meeting at School",
    href: "#",
  },
  {
    title: "7 Challenges Parents Face When Raising Preschoolers",
    href: "#",
  },
];
export const trendingNews = [
  {
    image: "/images/l.jpeg",
    author: "Sahara Team",
    date: "Apr 30, 2021",
    title:
      "Students learn to prioritize safety at Sahara Public Secondary School",
    excerpt:
      "Living a safe, hygienic, and dignified life is the measure of the true success of a country...",
    href: "#",
  },
  {
    image: "/images/primary.jpg",
    author: "Sahara Team",
    date: "Apr 28, 2021",
    title: "Students experience the world of Math-e-magic during the Math Camp",
    excerpt:
      "If we go down deep enough into anything, we will find Mathematics...",
    href: "#",
  },
  {
    image: "/images/d.jpeg",
    author: "Sahara Team",
    date: "Apr 24, 2021",
    title: "Students celebrate Earth Day themed 'Restore our Earth'",
    excerpt:
      "Sahara Public Secondary School celebrated Earth Day to inculcate environmental awareness...",
    href: "#",
  },
];

export const campusNews = [
  {
    image: "/images/d.jpeg",
    author: "Sahara Team",
    date: "Apr 24, 2026",
    title: "Students celebrate Earth Day at Sahara Public Secondary School",
    excerpt:
      "Students participated in a plantation drive and environmental awareness activities.",
    href: "#",
  },
  {
    image: "/images/high.jpg",
    author: "Sahara Team",
    date: "Apr 15, 2026",
    title: "Annual Science Exhibition inspires young innovators",
    excerpt:
      "Students showcased creative science models and innovative projects.",
    href: "#",
  },
  {
    image: "/images/j.jpeg",
    author: "Sahara Team",
    date: "Apr 10, 2026",
    title: "Inter-House Sports Championship concludes successfully",
    excerpt:
      "Students displayed teamwork and sportsmanship during the annual sports event.",
    href: "#",
  },
];

export const aroundSchool = [
  {
    thumbnail: "/assets/video-1.jpg",
    date: "Nov 15, 2024",
    title: "Sahara's Global Montessori Plus programme",
    excerpt:
      "Sahara's Global Montessori Plus programme offers a blend of the reputed Montessori approach and the...",
    href: "#",
  },
  {
    thumbnail: "/assets/video-2.jpg",
    date: "Nov 15, 2024",
    title: "Independence Day 2020 Celebrations",
    excerpt:
      "With hope in our hearts and courage in our veins, we will fight, and we will win. This #Independ...",
    href: "#",
  },
  {
    thumbnail: "/assets/video-3.jpg",
    date: "Jan 08, 2020",
    title: "Sahara Public Secondary School Global Championship League 2019",
    excerpt:
      "Sahara Public Secondary School organized a two-day 'Global Championship League' at campus...",
    href: "#",
  },
];

export const featuredBlogs = [
  {
    tags: "Schools, Learning",
    image: "/images/f.jpeg",
    title: "Cbse Admission Rules For Primary School And Secondary School",
    excerpt:
      "The Central Board of Secondary Education (CBSE) has set admission rules for primary and secondary schools in India.",
    author: "Seema Kaushik",
    date: "Feb 15, 2023",
    href: "#",
  },
  {
    tags: "Schools, Learning",
    image: "/images/e.jpeg",
    title: "Best Career Options After 12th Arts or Humanities Students",
    excerpt:
      "A career is one of the most important aspects of a student's life.",
    author: "Team Sahara",
    date: "Mar 10, 2023",
    href: "#",
  },
  {
    tags: "Schools, Learning",
    image: "/images/b.jpeg",
    title: "Best Career Options After 12th Commerce Stream",
    excerpt: "Choosing a career is one of the most important decisions.",
    author: "Seema Kaushik",
    date: "Mar 13, 2023",
    href: "#",
  },
];
